<template>
  <div class="hl-wid ww2 whx1 ubox">
    <div class="ub-head mb">
      <h2>{{ item.id?'Edit':'New' }} {{ entity }}</h2>
      <span class="ubh-ico user"></span>
    </div>
    <form class="user-form login" v-on:submit.prevent="saveProfile">
      <div class="uf-row split">
        <div>
          <label>Title</label>
          <input type="text" v-model="item.title" />
        </div>
      </div>
      <div class="uf-row to-c">
        <button class="main">Update</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data: ()=>({
    entity: "Playlist",
    sort: {title: null},
  }),
  methods: {
    async saveProfile() {
      var item={title: this.item.title};
      if (this.item.id)
        await api.update(this.entity, this.item.id, item);
      else {
        item.videos=[];
        await api.create(this.entity, item);
      }
      this.$emit("save");
    },
  },
}
</script>
